export default __webpack_public_path__ + "static/media/mamut_background_l1.9fefd286.jpg";